import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CastConnectedIcon from "@mui/icons-material/CastConnected";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import { Rating } from "@mui/material";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import i18next, { t } from "i18next";
import * as React from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import TextTruncate from "react-text-truncate";
import { APIExperience, NBD_Courses } from "../../config/constants";
import { handleEnrollement } from "../../utils";
import "./CourseCard.css";

export default function CourseCard(props) {
  const userLocation = useSelector(state => state.userLocationReducer)
  const { course, reviews, classes, enrollList = [] } = props;
  const instructor = course.instructors
    ? course?.instructors.filter((instruc) => {
      if (
        [
          "Thomas",
          "Hala Gamal",
          "Ahmed Moustafa",
          "Ahmed Moustafa TEST",
          "Mai Ahmed",
          "Amira Badr",
          "Omar Ahmed",
          "Customer Demo",
          "Mai Elbringy",
          "Saif Ryad",
        ].includes(instruc.name)
      )
        return null;
      else return instruc;
    })
    : [];
  const navigate = useNavigate();
  const session = JSON.parse(localStorage.getItem("user_stu") || "{}");
  const [Hours, Minutes] = [
    Number(course?.effort?.split(":")[0]) || null,
    Number(course?.effort?.split(":")[1]) || null,
  ];
  const location = useLocation();

  function NBD() {
    if (NBD_Courses.includes(course.course_id))
      return (
        <>
          <LocalOfferIcon
            className="iconsOfCourseCard "
            sx={{ fontSize: "18px" }}
          />
          <span> {t("All_Courses_Page_free")}</span>
        </>
      );
    else {
      return course?.modes[0]?.min_price ? (
        <>
          <CreditCardIcon
            className="iconsOfCourseCard "
            sx={{ fontSize: "18px" }}
          />
          {< span >
            {Math.ceil(course?.modes[0]?.min_price / userLocation[userLocation["Current_Location"]]["currency_rate"])} {t(userLocation[userLocation["Current_Location"]]["currency"])}
          </span >
          }
        </>
      ) : (
        <>
          <LocalOfferIcon
            className="iconsOfCourseCard "
            sx={{ fontSize: "18px" }}
          />
          <span> {t("All_Courses_Page_free")}</span>
        </>
      );
    }
  }

  const GetCourseName = ({ courseName }) => {
    let finalName =
      courseName.includes("|") && i18next.language === "ar"
        ? courseName.split("|")[1]
        : courseName.includes("|") && i18next.language === "en"
          ? courseName.split("|")[0]
          : courseName;

    return (
      <p
        style={{
          overflowWrap: "break-word",
          hyphens: "manual",
        }}
      >
        {finalName}
      </p>
    );
  };

  const getCourseDescriptionText = (description) => {
    return description.includes("|") && i18next.language === "ar"
      ? description.split("|")[1]
      : description.includes("|") && i18next.language === "en"
        ? description.split("|")[0]
        : description;
  };


  const CardRender = () => {
    return (
      <Card
        sx={{ width: "264px", cursor: "pointer" }}
        className={classes}
        onClick={(e) => {
          location.pathname.includes("details")
            ? (window.location.href = `/details/${course.course_id ? course.course_id : course.modes[0].course_id
              }`)
            : navigate(
              `/details/${course.course_id
                ? course.course_id
                : course.modes[0].course_id
              }`
            );
        }}
      >
        <CardMedia
          sx={{
            height: "148px",
            backgroundSize: "cover",
            backgroundPosition: "top",
          }}
          image={
            course?.instructors
              ? course?.media?.image?.raw
              : `${APIExperience}${course?.course_image_url}`
          }
          title={course?.course_id}
        />
        <CardContent sx={{ padding: "8px 8px 0px 8px" }}>
          <Typography
            variant="p"
            component="strong"
            sx={{ height: "2lh", display: "block" }}
          >
            {location.pathname.includes("instructor") ? (
              <GetCourseName courseName={course?.display_name} />
            ) : (
              <GetCourseName courseName={course?.name} />
            )}
          </Typography>
          <Typography
            sx={{ height: "2lh" }}
            gutterBottom
            variant="body2"
            component="div"
            color="text.secondary"
          >
            <TextTruncate
              className="textTruncate-coursespage"
              line={2}
              element="p"
              truncateText="…"
              text={getCourseDescriptionText(course?.short_description)}
            />
          </Typography>
          <Typography variant="p" className="text-capitalize">
            {instructor.length !== 0 ? (
              <>
                {t("With")} <strong>{instructor[0]?.name}</strong>
              </>
            ) : (
              <div style={{ visibility: "hidden" }}> ــ </div>
            )}
          </Typography>
        </CardContent>
        <CardActions
          sx={{
            minHeight: "4.9lh",
            justifyContent: "space-between",
            paddingInline: "8px",
          }}
        >
          <div style={{ color: "grey" }}>
            <section className="d-flex gap-1 justify-content-start align-items-center p-0 m-0">
              <NBD />
            </section>
            <section className="d-flex gap-1 justify-content-start p-0 m-0">
              {course?.pacing === "self" ? (
                <>
                  <OndemandVideoIcon
                    className="iconsOfCourseCard"
                    sx={{ fontSize: "5rem" }}
                  />
                  <span style={{ fontSize: ".8rem" }}>
                    {t("All_Courses_Page_recorded")}
                  </span>
                </>
              ) : (
                <>
                  <CastConnectedIcon
                    className="iconsOfCourseCard "
                    sx={{ fontSize: "18px" }}
                  />
                  {t("All_Courses_Page_live")}
                </>
              )}
            </section>
            <section
              className="d-flex gap-1 justify-content-start align-items-center p-0 m-0"
              style={{
                visibility: ` ${course.effort ? "visibile" : "hidden"} `,
              }}
            >
              <AccessTimeIcon
                className="iconsOfCourseCard "
                sx={{ fontSize: "18px" }}
              />
              {Hours && (
                <p className="m-0">
                  <small>
                    {t("Hour_interval", {
                      postProcess: "interval",
                      count: Hours,
                    })}
                  </small>
                </p>
              )}
              {Minutes && (
                <p className="m-0">
                  <small>
                    {t("Minute_interval", {
                      postProcess: "interval",
                      count: Minutes,
                    })}
                  </small>
                </p>
              )}
            </section>
            {reviews && (
              <section>
                <Rating
                  sx={{
                    direction: "ltr",
                  }}
                  readOnly
                  name="read-only"
                  size="small"
                  precision={0.5}
                  value={
                    course?.org === 'Soft_Skills' || course?.org === 'Finance_and_Accounting' || course?.org === 'Marketing' ? 4 : course?.org === 'Oil_and_Gas' || course?.org === 'Oil_and_Gas' ? 3 : 5}
                />
              </section>
            )}
          </div>
          <div className="d-flex align-items-end" style={{ height: "4lh" }}>
            <button
              aria-label="button to be clicked"
              aria-labelledby="button to be clicked"
              disabled={NBD_Courses.includes(course.course_id)}
              className={`btn test2 ${enrollList.find(
                (e) => e.course_details.course_id === course.course_id
              )
                ? "btn-success"
                : "btn-warning"
                }  `}
              onClick={(e) => {
                e.stopPropagation();
                handleEnrollement(course, session, navigate);
              }}
            >
              {enrollList &&
                enrollList?.find(
                  (e) => e.course_details.course_id === course.course_id
                ) && <CheckCircleOutlineIcon fontSize="small" />}
              {enrollList &&
                enrollList?.find(
                  (e) => e.course_details.course_id === course.course_id
                )
                ? `${t("Enrolled")}`
                : course.pacing === "instructor" &&
                  course.enrollment_end &&
                  course?.max_student_enrollments_allowed <=
                  course?.student_enrollments_count
                  ? `${t("Completed")}`
                  : `${t("Enroll")}`}
            </button>
          </div>
        </CardActions>
      </Card>
    );
  };

  return (
    <>
      <CardRender />
    </>
  );
}
